import { Component } from "./Component";
import { MediaAdapterSubs } from "../adapters/MediaAdapter";
import { settings } from "../const/Settings";
import { vp } from "../managers/vp";
import { VideoEndScreen } from "./VideoEndScreen";
import { api } from "../libs/apis/api";
import { MediaListModel } from "../models/MediaListModel";
var videoTypes = settings.videoTypes;
import { isLocalDevelopment } from "socios-tools/const/sociosSettings";
export class VideoPlayer extends Component {
    constructor() {
        super(require("../../html/VideoPlayer.handlebars")());
        this._endScreen = null;
        this._playerHtml = this.getHtml('player');
    }
    init(videoModel) {
        this._videoModel = videoModel;
        this._adapter = null;
        this.html.setAttribute('data-type', videoModel.type);
        try {
            switch (videoModel.type) {
                case videoTypes.youtube:
                    this._adapter = vp.blackboard.youtubeAdapter;
                    break;
                case videoTypes.twitter:
                    this._adapter = vp.blackboard.twitterAdapter;
                    break;
            }
            let trackedEvent = {};
            const trackEvent = (action) => {
                log('trackEvent', action);
                if (!trackedEvent[action]) {
                    trackedEvent[action] = true;
                    vp.statisticsManager.trackEvent({
                        category: 'video-type',
                        action: action,
                        label: videoModel.type
                    });
                    vp.statisticsManager.trackEvent({
                        category: 'video-adapter',
                        action: action,
                        label: this._adapter.name
                    });
                }
            };
            if (this._adapter) {
                trackEvent('init');
                this.html.setAttribute('data-adapter', this._adapter.name);
                this._adapter.init(videoModel.params);
                this._adapter.listener.subscribe((subs) => {
                    switch (subs) {
                        case MediaAdapterSubs.onStateChange:
                            if (this._adapter.currentState === 'ended') {
                                trackEvent('ended');
                                this.showEndScreen();
                            }
                            else if (this._adapter.currentState === 'playing') {
                                vp.userPlayedVideo(videoModel, this._adapter);
                                trackEvent('playing');
                            }
                            else if (this._adapter.currentState === 'commercial-block') {
                                trackEvent('commercial-block');
                            }
                            else if (this._adapter.currentState === 'error') {
                                trackEvent('error');
                            }
                            else if (this._adapter.currentState === 'play') {
                                trackEvent('start');
                            }
                            break;
                    }
                });
                this._adapter.appendTo(this._playerHtml, isLocalDevelopment ? settings.dAutoPlayVideos : true);
                vp.blackboard.curMediaAdapters.forEach((adapter) => {
                    if (adapter) {
                        try {
                            adapter.stop();
                        }
                        catch (e) {
                        }
                    }
                });
                vp.blackboard.curMediaAdapters.push(this._adapter);
            }
            else {
                logger.error('no adapter for ' + videoModel.type);
            }
        }
        catch (e) {
            logger.error(e.stack);
        }
    }
    showEndScreen() {
        if (!this._endScreen && this._adapter && this._videoModel.endedSuggestionsApiUrl) {
            api.get(this._videoModel.endedSuggestionsApiUrl).then((result) => {
                if (result.body.ended) {
                    this._endScreen = new VideoEndScreen();
                    this._endScreen.init(new MediaListModel(result.body), () => {
                        this._adapter.play();
                        this._endScreen = null;
                    });
                    this.html.appendChild(this._endScreen.html);
                }
            }).catch((e) => {
                logger.error(e.stack);
            });
        }
    }
    destroy() {
        if (this._adapter) {
            try {
                this._adapter.destroy();
            }
            catch (e) {
                logger.error(e);
            }
        }
    }
}
